import { createSelector } from '@ngrx/store';

import { onlineMenuProductsImagesState } from '../root';

export const getImagesForOnlineMenuPages = createSelector(onlineMenuProductsImagesState, (onlineMenuPagesImages) => onlineMenuPagesImages);
